import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DynamicCheckboxBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  selector: 'ups-dynamic-checkbox',
  styleUrls: ['dynamic-checkbox.component.scss'],
  template: `
    <div class="dynamic-field-container" [class.selected]="config?.selected">
      <div
        class="dynamic-field form-input text-align"
        [formGroup]="group"
        [hidden]="!config?.isFormBuilder && config?.options?.hidden"
      >
        @if (config?.instruction) {
          <p class="mb-3">{{ config.instruction }}</p>
        }
        <label kendoTooltip>
          <input
            class="k-checkbox mr-2"
            [attr.name]="config.formControlName"
            [formControlName]="config.formControlName"
            (change)="checkValue($event)"
            type="checkbox"
          />
          <span [ngStyle]="config?.options?.style?.label">
            {{ config?.label }}
          </span>
          @if (config?.options?.tooltip) {
            <i
              class="far fa-info-circle"
              [title]="config?.options?.tooltip"
            ></i>
          }
        </label>
        @if (config?.isFormBuilder) {
          <div
            class="form-builder-mask"
            [class.hidden]="config?.options?.hidden"
          ></div>
        }
      </div>
      @if (config?.isFormBuilder) {
        <div class="form-builder-options">
          <i
            class="fas fa-times ml-3 cursor-pointer c-red"
            (click)="delete()"
          ></i>
          <!-- <i class="fas fa-bars ml-3 cursor-grab "></i> -->
        </div>
      }
    </div>
  `,
  // WI 35584: base-class marks cover async writes; ngDoCheck covers in-place config flags.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicCheckboxComponent
  extends DynamicCheckboxBaseComponent
  implements OnInit
{
  checkValue(args) {
    if (args && args.target) {
      this.updateConfigTargets(args);
    }
  }
}
